import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { GenericCDataCopySource, GenericCDataLinkedService } from 'shell-models-lib';

export const genericCDataMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(GenericCDataLinkedService).name,
    displayName: stringResources.GenericCData_DisplayText,
    linkedServiceKind: 'table',
    linkedServiceNamePrefix: 'GenericCData',
    icon: {
        className: 'svg-i-100x100-PlaceHolderDatabase'
    },
    isFirstClass: true,
    supportedInTrident: true,
    supportDatasetV2: true,
    supportAutoFillCopilotInput: true,
    isKnownInPipelineContext: true,
    supportCopyJobSource: true,
    supportCopyJobSink: false,
    supportGetMetadataActivity: true,
    supportStoredProcedureActivity: true,
    supportScriptActivity: true,
    category: ['GenericProtocol'],
    copySourceTypes: [Metamodel.modelFor(GenericCDataCopySource).name],
    copySinkTypes: [],
    controls: []
};
